type DisplayTitleMetafield = string | { value?: string | null } | null | undefined

export function productDisplayTitle(
  title: string,
  metafields?: { display_title?: DisplayTitleMetafield },
): string {
  const raw = metafields?.display_title
  const displayTitle =
    typeof raw === "object" && raw !== null && raw.value != null ? raw.value : raw

  if (typeof displayTitle === "string" && displayTitle.trim()) {
    return displayTitle.trim()
  }

  return title.split("|")[0]?.trim() || title
}
